
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/guides/telemetry",
      function () {
        return require("private-next-pages/x/guides/telemetry.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/guides/telemetry"])
      });
    }
  